import { Injectable, signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  // Modern Angular signal
  isLoading = signal(false);

  // Backward-compatible observable (derived from signal)
  readonly isLoading$ = toObservable(this.isLoading);

  private loadingCounter = 0;

  show(): void {
    this.loadingCounter++;
    this.updateLoadingState(true);
  }

  hide(): void {
    if (this.loadingCounter > 0) {
      this.loadingCounter--;
    }

    if (this.loadingCounter === 0) {
      this.updateLoadingState(false);
    }
  }

  forceHide(): void {
    this.loadingCounter = 0;
    this.updateLoadingState(false);
  }

  private updateLoadingState(loading: boolean): void {
    this.isLoading.set(loading);
  }
}